'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';

  lastId++;
  return '' + prefix + lastId;
};

var lastId = 0;

/**
 * Funkce, která generuje unikátní id, např. pro tooltipy apod.
 *
 * Použití:
 * import newId from "....newId";
 *
 * constructor(props) {
 *   super(props);
 *   this.uniqueId = newId();
 * }
 *
 * @param prefix
 * @return {string}
 */
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZm9ybS9uZXdJZC5qc3giXSwibmFtZXMiOlsicHJlZml4IiwibGFzdElkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7a0JBZ0JlLFlBQXlCO0FBQUEsTUFBZkEsTUFBZSx1RUFBTixJQUFNOztBQUNwQ0M7QUFDQSxjQUFVRCxNQUFWLEdBQW1CQyxNQUFuQjtBQUNILEM7O0FBbkJELElBQUlBLFNBQVMsQ0FBYjs7QUFFQSIsImZpbGUiOiJuZXdJZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImxldCBsYXN0SWQgPSAwO1xuXG4vKipcbiAqIEZ1bmtjZSwga3RlcsOhIGdlbmVydWplIHVuaWvDoXRuw60gaWQsIG5hcMWZLiBwcm8gdG9vbHRpcHkgYXBvZC5cbiAqXG4gKiBQb3XFvml0w606XG4gKiBpbXBvcnQgbmV3SWQgZnJvbSBcIi4uLi5uZXdJZFwiO1xuICpcbiAqIGNvbnN0cnVjdG9yKHByb3BzKSB7XG4gKiAgIHN1cGVyKHByb3BzKTtcbiAqICAgdGhpcy51bmlxdWVJZCA9IG5ld0lkKCk7XG4gKiB9XG4gKlxuICogQHBhcmFtIHByZWZpeFxuICogQHJldHVybiB7c3RyaW5nfVxuICovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiAocHJlZml4ID0gJ2lkJykge1xuICAgIGxhc3RJZCsrO1xuICAgIHJldHVybiBgJHtwcmVmaXh9JHtsYXN0SWR9YDtcbn1cbiJdfQ==